import React from 'react'

const ReadOnlyDropdown = ({ options }) => {

    if (!options || options.length === 0) {
        return <p>-</p>; // Display a dash if there are no options
    }

    return (
        <select className="filterInput" style={{ border: "none", paddingLeft: 0 }}>
            <option value="" disabled selected hidden>{options[0]?.label}</option>
            {options.map((option) => (
                <option disabled key={option.value} value={option.value} style={{ backgroundColor: "#21173a", color: "#fff" }}>
                    {option.label}
                </option>
            ))}
        </select>
    )
}

export default ReadOnlyDropdown